import { Component, HostListener, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { PageHeadingState, showPageHeading } from './selectors/page-heading.selector';
import { TranslateService } from '@ngx-translate/core';
import { CommonUtils } from './common/util/common.util';
import { ValidationUtil } from './common/util/validation.util';
import { AuthUtil } from './common/util/auth.util';
import { CartUtil } from './common/util/cart.util';
import { UserProfileService } from './services/myoffice/user-profile/user-profile.service';
import { CartService } from './services/shoppingmall/cart.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'medius-shop';
  // handle để đóng tab sẽ mất
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: BeforeUnloadEvent) {
    let deviceId = localStorage.getItem("device_id");
    this._cartService.deleteAllSidBeacon(String(deviceId))
  }

  showPageHeading$ = new Observable<boolean>();

  constructor(
    private _pageHeadingStore: Store<PageHeadingState>,
    private _translate: TranslateService,
    private _userProfileService : UserProfileService,
    private _cartService : CartService
    ) { 
    this.showPageHeading$ = this._pageHeadingStore.select(showPageHeading);
  }

  async ngOnInit(): Promise<void> {
    let messages = CommonUtils.getMessages();
    this._translate.use(messages);
    const urlParams = new URLSearchParams(window.location.search);
    let deviceId = localStorage.getItem("device_id");
    
    if (!deviceId) {
      deviceId = CommonUtils.generateDeviceId(20); // Tạo ID duy nhất xóa localstronge mới mất được id để xác định giỏ hàng thuộc thiết bị nào
      localStorage.setItem("device_id", deviceId);
    }
    if(AuthUtil.isLogined())
    {
      // xóa link_userid khi login
      setTimeout(() => {
        this._cartService.deleteAllSid(String(deviceId))
        sessionStorage.removeItem("userid_link_order");
        sessionStorage.removeItem("infoMemberOrderLink");
        sessionStorage.removeItem("login_id");
      }, 100);
      
    }
    let userId = urlParams.get('userid_link_order') 
    if(ValidationUtil.isNotNullAndNotEmpty(userId) && ValidationUtil.isNotNullAndNotEmpty(deviceId)){
      userId = userId + "_" +deviceId;
    }
    const userIdOld = sessionStorage.getItem("userid_link_order");
    // remove ord_tmp khi useridOld không tồn tại
    if(ValidationUtil.isNullOrEmpty(userIdOld)){
        this._cartService.deleteAllSid(deviceId).subscribe(res => {
          console.log("Kết quả:", res);
        });

    }
    if(userIdOld != userId && ValidationUtil.isNotNullAndNotEmpty(userId) && !AuthUtil.isLogined())
    {
        this._cartService.deleteAllSid(deviceId).subscribe(res => {
          console.log("Kết quả:", res);
        });
        sessionStorage.removeItem("login_id");
        sessionStorage.setItem("userid_link_order" , String(userId));
        await this._userProfileService.getUserProfile(String(urlParams.get('userid_link_order'))).subscribe(
          res => {
            if(ValidationUtil.isNotNullAndNotEmpty(res)) {
              const infoMemberOrderLink = {
                userid: res.userid,
                cntCd: res.cntCd,
                username : res.username,
                logId : res.logId
              };
              sessionStorage.setItem("infoMemberOrderLink", JSON.stringify(infoMemberOrderLink));
            }else{
              sessionStorage.removeItem("infoMemberOrderLink");
            }
          }
        );
    }
  }
}
